import { createSelector } from "@reduxjs/toolkit";

// 🚧 TODO(Sarah): MOCK AUTH SELECTORS FOR RBC 🚧
// These are temporary mock implementations until proper auth integration
// They return safe default values to prevent runtime errors

const MOCK_ENABLE_POINTS_TESTING = true; // Set to true to test points functionality

export const getIsLoading = (state?: any): boolean => {
  // Mock: Never loading for now
  return false;
};

export const getIsLoggingIn = (state?: any): boolean => {
  // Mock: Never logging in for now
  return false;
};

export const getIsVerified = createSelector(
  () => MOCK_ENABLE_POINTS_TESTING, // Mock: Return true to enable points testing
  (mockEnabled) => mockEnabled
);

export const getIsAnonymous = createSelector(
  () => !MOCK_ENABLE_POINTS_TESTING, // Mock: Return opposite of verified
  (isAnonymous) => isAnonymous
);

export const getIsAuthenticated = createSelector(
  getIsVerified,
  getIsAnonymous,
  (isVerified, isAnonymous) => isVerified || isAnonymous
);

export const getUserStateUpdated = (state?: any): boolean => {
  // Mock: Always false for now
  return false;
};

export const getShouldIgnoreUserStateUpdated = (state?: any): boolean => {
  // Mock: Always false for now
  return false;
};

export const getFirstName = (state?: any): string | undefined => {
  // Mock: Return test data
  return MOCK_ENABLE_POINTS_TESTING ? "Test" : undefined;
};

export const getLastName = (state?: any): string | undefined => {
  // Mock: Return test data
  return MOCK_ENABLE_POINTS_TESTING ? "User" : undefined;
};

export const getPhoneNumber = (state?: any): string | undefined => {
  // Mock: Return undefined for now
  return undefined;
};

export const getEmail = (state?: any): string | undefined => {
  // Mock: Return test data
  return MOCK_ENABLE_POINTS_TESTING ? "test@rbc.com" : undefined;
};

export const getIsFirstSession = (state?: any): boolean => {
  // Mock: Always false for now
  return false;
};

export const getHasRewards = (state?: any): boolean | undefined => {
  // Mock: Enable rewards for testing if authenticated
  const isVerified = getIsVerified(state);
  return isVerified ? MOCK_ENABLE_POINTS_TESTING : undefined;
};

export const getHopperUserId = (state?: any): string | undefined => {
  // Mock: Return test ID
  return MOCK_ENABLE_POINTS_TESTING ? "mock-hopper-user-id" : undefined;
};

export const getKustomerAccessToken = (state?: any): string | undefined => {
  // Mock: Return undefined for now
  return undefined;
};
